/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow

import type { Element } from 'react';

import React from 'react';
import { STRUCTURAL_RESPONSE_ITEM_KEY } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import Tip from '#components/support/tooltips/Tip/index.jsx';

type Props = {|
  original: {
    edpKey: string,
    abbreviation: string,
    itemKey: string,
  },
|};

const EdpCell = (props: Props): Element<'div'> => {
  const {
    original: { edpKey, abbreviation, [STRUCTURAL_RESPONSE_ITEM_KEY]: itemKey },
  } = props;
  return (
    <div className="text-nowrap">
      <div className="float-left">
        {abbreviation} <Tip tipId={edpKey} targetId={`${edpKey}-${itemKey}`} />
      </div>
    </div>
  );
};

export default EdpCell;
